/**
 * Build a URL for a static file under `public/`, encoding each path segment
 * (spaces, parentheses, unicode) for safe use in `src` attributes.
 * @param {string} pathFromPublicRoot e.g. "VICKY/Face/BUCCAL FAT REDUCTION.jpg"
 * @returns {string} e.g. "/VICKY/Face/BUCCAL%20FAT%20REDUCTION.jpg"
 */
export function encodePublicImagePath(pathFromPublicRoot) {
  return "/" + pathFromPublicRoot.split("/").map(encodeURIComponent).join("/");
}
